import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"
import { connect } from "react-redux"
import { Icon } from "quorumdesign"
import Tooltip from "app/static/frontend/components/Tooltip"
import { filterWarningText } from "app/static/frontend/sheets/components/helpTexts"
import { columnSearchTriggerConnection } from "app/static/frontend/sheets/column-search-selectors"
import { searchByColumnAtIndex, focusColumn, unfocusColumn } from "app/static/frontend/sheets/sheet-action-creators"
import "rc-slider/assets/index.css"

/**
 * This component renders the Search component for a Column in Sheets
 */
export class ResourceTableColumnSearchTrigger extends React.Component {
    constructor(props) {
        super(props)
        this.search = this.search.bind(this)
        this.focus = this.focus.bind(this)
        this.unfocus = this.unfocus.bind(this)
    }

    focus(e) {
        this.props.canSearch && this.props.focusColumn(this.props.id, this.props.columnIndex)
    }

    unfocus() {
        this.props.unfocusColumn(this.props.id, this.props.columnIndex)
    }

    /**
     * This function calls the provided action creator that is passed as
     * searchByColumnAtIndex
     * Don't call this function if the column does not support filtering
     * @name search
     * @function
     * @param {Any} value - The value the user is searching the column by
     */
    search(value) {
        if (this.props.canSearch) {
            this.props.searchByColumnAtIndex(this.props.id, this.props.columnIndex, value)
        }
    }

    renderSearchTrigger() {
        const SearchTrigger = this.props.SearchTrigger
        return (
            <SearchTrigger
                canFitInMemory={this.props.canFitInMemory}
                column={this.props.column}
                columnData={this.props.columnData}
                columnIndex={this.props.columnIndex}
                columnRange={this.props.columnRange}
                customTag={this.props.customTag}
                id={this.props.id}
                field={this.props.field}
                loading={this.props.loading}
                search={this.search}
                unfocusColumn={this.unfocus}
                value={this.props.value}
            />
        )
    }

    renderPopover() {
        return (
            <Popover id="search-column-popover" placement="bottom">
                <div className="popover-title">Filter this column...</div>
                <div className="popover-content">{this.props.canSearch && this.renderSearchTrigger()}</div>
            </Popover>
        )
    }

    renderTooltip = ({ ref, ...triggerHandler }) => (
        <Tooltip label={this.props.canSearch ? "Filter" : filterWarningText}>
            <div
                className={this.props.isSearching ? "column-icon-active" : "column-icon"}
                data-cy={this.props.dataCy}
                {...triggerHandler}
                ref={ref}
            >
                <Icon icon="filter" iconFamily={this.props.isSearching ? "fas" : "fal"} />
            </div>
        </Tooltip>
    )

    render() {
        if (this.props.canSearch) {
            return (
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={this.renderPopover()}
                    onEntered={this.focus}
                    onExit={this.unfocus}
                    rootClose
                    dataCy="column-filter"
                >
                    {({ ref, ...triggerHandler }) => this.renderTooltip({ ref, ...triggerHandler })}
                </OverlayTrigger>
            )
        } else {
            return this.renderTooltip()
        }
    }
}

export default connect((state, props) => columnSearchTriggerConnection(state, props), {
    focusColumn,
    searchByColumnAtIndex,
    unfocusColumn,
})(ResourceTableColumnSearchTrigger)
